import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import APIConfig from "../APIConfig";
import AuthAPI from "../AuthAPI";

const getClockingFormData = (idDipendente, position) => {
    const formData = new FormData();
    formData.append("token", AuthAPI.getUserAccessToken());
    formData.append("id_dipendente", idDipendente);
    if (position) {
        formData.append("lat", position.lat);
        formData.append("lon", position.lon);
    }
    return formData;
};

const submitPresence = (action, idDipendente, position) => {
    return FuxHTTP.apiPostRequestWithPromise(
        APIConfig.url(`/modulo-hr/clocking-sessions/app/${action}-presence`),
        getClockingFormData(idDipendente, position),
        FuxHTTP.RESOLVE_RESPONSE,
        FuxHTTP.REJECT_MESSAGE
    );
};

export const _ClockingSessions = {
    presenceData: idDipendente => {
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url("/modulo-hr/clocking-sessions/app/presence-data"),
            {
                token: AuthAPI.getUserAccessToken(),
                staff_member_id: idDipendente
            },
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    startPresence: (idDipendente, position) => submitPresence("start", idDipendente, position),
    stopPresence: (idDipendente, position) => submitPresence("stop", idDipendente, position)
};
